import React, { useState, useEffect } from "react";
import "./editDepartmentPrice.css";
import Widgets from "../../widgets";
import ClockIcon from "../../Assets/Icons/Clock.png";
import useValidation from "../../utils/validators";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateDepartmentPrice, deleteDepPrice } from "../../modules/department/departmentThunk";
import { resetUpdateDepPrice, resetDelDepPrice } from "../../modules/department/departmentSlice";
import { NumericFormat } from "react-number-format";
import ToastPopup from "../../widgets/Toast/toastPopup";

const EditDepartmentPrice = ({ setSelectedView, data }) => {
  const dispatch = useDispatch();
  const { updateDepPriceSuccess, updateDepPriceErr, delDepPriceSuccess, delDepPriceErr } = useSelector((state) => state.department);
  const selectedLanguage = useSelector((state) => state.language.language);

  useEffect(() => {
    if (updateDepPriceErr) {
      ToastPopup.error(updateDepPriceErr);
    }
    if (updateDepPriceSuccess && updateDepPriceSuccess.status === "success") {
      ToastPopup.success(t("depUpdated"));
      setSelectedView("departmentPrice");
    }
    dispatch(resetUpdateDepPrice());
  }, [updateDepPriceSuccess, updateDepPriceErr]);

  useEffect(() => {
    if (delDepPriceErr) {
      ToastPopup.error(delDepPriceErr);
    }
    if (delDepPriceSuccess && delDepPriceSuccess.status === "success") {
      ToastPopup.success(t("entryDel"));
      setSelectedView("departmentPrice");
    }
    dispatch(resetDelDepPrice());
  }, [delDepPriceErr, delDepPriceSuccess]);

  const breadcrumbs = ["video_Consultation", "depPriceDetails"];
  const paths = [{ path: "/department-price", onClick: () => setSelectedView("departmentPrice") }, "/department-price"];
  const [opdInternational, setOpdInternational] = useState(data.price?.opdInternational.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  const [opdLocal, setOpdLocal] = useState(data.price?.opdLocalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  const [opdSubsidized, setOpdSubsidized] = useState(data.price?.opdSubsidized.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { validateDepartmentPrice } = useValidation();
  const { t } = useTranslation();

  const handleCancel = () => {
    setSelectedView("departmentPrice");
    // ToastPoup.error("Cancel Button Clicked");
  };

  const handleSave = () => {
    const selectedData = {
      name: data.departmentName,
      duration: data.duration,
      grade: data.grade,
      code: data.priceCode,
      opdInternational: opdInternational,
      opdLocal: opdLocal,
      opdSubsidized: opdSubsidized,
    };
    if (validateDepartmentPrice(selectedData)) {
      const hasChanges =
        data.price?.opdInternational !== opdInternational.replace(/,/g, "") ||
        data.price?.opdLocalPrice !== opdLocal.replace(/,/g, "") ||
        data.price?.opdSubsidized !== opdSubsidized.replace(/,/g, "");

      if (hasChanges) {
        const body = {
          priceCode: data.priceCode,
          opdInternationalPrice: opdInternational.replace(/,/g, ""),
          opdLocalPrice: opdLocal.replace(/,/g, ""),
          opdSubsidized: opdSubsidized.replace(/,/g, ""),
        };
        dispatch(updateDepartmentPrice(body));
      } else {
        ToastPopup.error(t("noChanges"));
      }
    }
  };
  const handleDelete = () => {
    setShowDeleteModal(true);
  };
  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };
  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    const priceCode = data.priceCode;
    dispatch(deleteDepPrice({ priceCode }));
  };
  return (
    <div className="dpa-primary">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{data.priceCode}</div>
      <div className="dp-create-price">
        <div className="dp-price-body">
          <div className="department-heading-row">
            <p className="dp-body-h1">
              {t("setDepPrice")}
              <span className="astrik">*</span>
            </p>
            {data.price && (
              <div className="department-del-btn" onClick={handleDelete}>
                {t("delEntry")}
              </div>
            )}
          </div>
          <div className="dp-department">
            <div className="dp-box-price">
              <div className="dp-item-row">
                <div className="dp-box-item">
                  {t("name")}
                  <Widgets.SelectDropdown
                    selectedValue={selectedLanguage === "vietnam" ? data.departmentName.vi : data.departmentName.en}
                    backgroundColor="var(--bg-select-green)"
                    textColor="var(--color-green)"
                    disabled
                  />
                </div>
                <div className="divider" />
                <div className="dp-box-item">
                  {t("duration")}
                  <Widgets.SelectDropdown selectedValue={data.duration + " " + t("min")} extraIcon={ClockIcon} backgroundColor="var(--bg-select-green)" textColor="var(--color-green)" disabled />
                </div>
                <div className="divider" />
                <div className="dp-box-item">
                  {t("grade")}
                  <Widgets.SelectDropdown selectedValue={data.grade} placeholder="Select Grade" backgroundColor="var(--bg-select-green)" textColor="var(--color-green)" disabled />
                </div>
              </div>
              <div className="divider last" />
              <div className="dp-box-item id">{data.priceCode}</div>
            </div>
            <div className="dp-price-opd">
              <div className="dp-boxes">
                <p>OPD International Insured</p>
                <div>
                  <span>₫</span>
                  <NumericFormat thousandSeparator="," allowNegative={false} decimalScale={2} value={opdInternational} onValueChange={(values) => setOpdInternational(values.formattedValue)} />
                </div>
              </div>
              <div className="dp-boxes">
                <p>OPD Local Insured</p>
                <div>
                  <span>₫</span>
                  <NumericFormat thousandSeparator="," allowNegative={false} decimalScale={2} value={opdLocal} onValueChange={(values) => setOpdLocal(values.formattedValue)} />
                </div>
              </div>
              <div className="dp-boxes">
                <p>OPD Subsidized</p>
                <div>
                  <span>₫</span>
                  <NumericFormat thousandSeparator="," allowNegative={false} decimalScale={2} value={opdSubsidized} onValueChange={(values) => setOpdSubsidized(values.formattedValue)} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="save-speciality dp-price-footer">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          <div className="speciality-save" onClick={handleSave}>
            {t("save")}
          </div>
        </div>
      </div>
      <Widgets.ConfirmModal showModal={showDeleteModal} handleCancel={handleCancelDelete} handleConfirm={handleConfirmDelete} heading={t("delDepPrice")} description={t("askPriceDel")} />
    </div>
  );
};

export default EditDepartmentPrice;
